import { PageInterface } from "../interfaces";
import ModelsPage from "../sections/agency/ModelsPage";
import ModelDetailsPage from "../sections/agency/modelSubsections/ModelDetailsPage";
import ModelEditPage from "../sections/agency/modelSubsections/ModelEditPage";
import OffersPage from "../sections/agency/OffersPage";
import OfferDetailsPage from "../sections/agency/offersSubsections/OfferDetailsPage";
import ShareOfferPage from "../sections/agency/offersSubsections/ShareOfferPage";
import OverviewPage from "../sections/agency/OverviewPage";
import ClientsPage from "../sections/general/ClientsPage";
import ClientDetailsPage from "../sections/general/clientSubsections/ClientDetailsPage";
import SettingsPage from "../sections/general/SettingsPage";
import UserDetailsPage from "../sections/general/settingSubsections/UserDetailsPage";
import { toIcons } from "./Paths";

export const contentPagesList: PageInterface[] = [
  {
    name: "overview",
    pathName: "/overview",
    displayName: "Overview",
    iconPath: `${toIcons}/overview.svg`,
    pageElement: OverviewPage,
  },
  {
    name: "models",
    pathName: "/models",
    displayName: "Models",
    iconPath: `${toIcons}/models.svg`,
    pageElement: ModelsPage,
    subsection: [
      {
        name: "model_details",
        pathName: "/models/:id",
        displayName: "Model Details",
        pageElement: ModelDetailsPage,
      },
      {
        name: "edit_model",
        pathName: "/models/:id/edit",
        displayName: "Edit Model",
        pageElement: ModelEditPage,
      },{
        name: "create_model",
        pathName: "/models/create",
        displayName: "Create Model",
        pageElement: ModelEditPage,
      },
    ],
  },
  {
    name: "offers",
    pathName: "/offers",
    displayName: "Offers",
    iconPath: `${toIcons}/offers.svg`,
    pageElement: OffersPage,
    subsection: [
      {
        name: "offer_details",
        pathName: "/offers/:id",
        displayName: "Offer Details",
        pageElement: OfferDetailsPage,
      },
      {
        name: "share_offer",
        pathName: "/offers/share/:id",
        displayName: "Offer Share",
        pageElement: ShareOfferPage,
      },
    ],
  },
  {
    name: "clients",
    pathName: "/clients",
    displayName: "Clients",
    iconPath: `${toIcons}/clients.svg`,
    pageElement: ClientsPage,
    subsection: [
      {
        name: "client_details",
        pathName: "/clients/:id",
        displayName: "Client Details",
        pageElement: ClientDetailsPage,
      },
    ],
  },
  {
    name: "settings",
    pathName: "/settings",
    displayName: "Settings",
    iconPath: `${toIcons}/settings.svg`,
    pageElement: SettingsPage,
    subsection: [
      {
        name: "user_details",
        pathName: "/settings/user/:id",
        displayName: "User Details",
        pageElement: UserDetailsPage,
      },
    ],
  },
];
